import PatientBill from './PatientBill';

export default PatientBill;
